import React from 'react';

// Material-UI
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link'

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.instagram.com/ksrpmiunitunj/" target="_blank" style={{textDecoration: "none", color: "red"}}>
        {"PCAB KSR PMI UNIT UNJ"}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};

export default Copyright


